import noop from 'lodash/noop';
import { ReactComponent as SvgChevronLeft } from '@img/icons/chevron-left.svg';
import { ReactComponent as SvgChevronDown } from '@img/icons/chevron-down.svg';
import React from 'react';
import S from './FilterList.styles';
const FilterCheckItem = ({ id, text, name, value, ...otherProps }) => {
    return (React.createElement(S.CheckboxItemContainer, null,
        React.createElement(S.CheckboxItem, { htmlFor: id },
            React.createElement(S.CheckboxInput, { id: id, name: name, value: value, ...otherProps }),
            React.createElement(S.CheckboxText, null,
                text,
                React.createElement(S.Tick, null)))));
};
const FilterList = ({ activeId, categoryValues, filterValue, items, multi, sortByOptions, sortByValue, title, topicValues, 
// onApply,
onCancel, onClear, 
// onRemove,
onCheckBoxChange, onFilterChange, onSelect, onSortChange = noop, setVisible, }) => {
    function updateCheckboxArray(e, key) {
        if (key === 'category' && categoryValues && onCheckBoxChange) {
            const tempValues = categoryValues;
            if (!tempValues.includes(e)) {
                tempValues.push(e);
                onCheckBoxChange(key, tempValues);
            }
            else {
                const newList = tempValues.filter((prof) => prof !== e);
                onCheckBoxChange(key, newList);
            }
        }
        if (key === 'topic' && topicValues && onCheckBoxChange) {
            const tempValues = topicValues;
            if (!tempValues.includes(e)) {
                tempValues.push(e);
                onCheckBoxChange(key, tempValues);
            }
            else {
                const newList = tempValues.filter((prof) => prof !== e);
                onCheckBoxChange(key, newList);
            }
        }
    }
    return (React.createElement(S.ItemList, null,
        React.createElement(S.Top, null,
            React.createElement(S.Title, { disabled: !onCancel, onClick: (event) => {
                    event.preventDefault();
                    onCancel && onCancel();
                } },
                onCancel && React.createElement(SvgChevronLeft, null),
                title),
            onClear && (React.createElement(S.Clear, { type: "button", onClick: (event) => {
                    event.preventDefault();
                    onClear();
                } },
                React.createElement(S.Close, null),
                "Clear all"))),
        multi &&
            multi.map((item) => (React.createElement(S.CheckboxAreaContainer, { key: item.id },
                React.createElement(S.Item, { isActive: activeId === item.value, onClick: (event) => {
                        event.preventDefault();
                        onSelect(activeId === item.value ? '' : item.value ?? '');
                    } },
                    React.createElement("span", null, item.text),
                    React.createElement(S.Arrow, null,
                        React.createElement(SvgChevronDown, null))),
                React.createElement(S.CheckboxAreaItems, { active: activeId === item.value }, item.options?.map((item) => (React.createElement(FilterCheckItem, { key: item.id, type: "checkbox", checked: item.name === 'topic'
                        ? topicValues?.includes(item.value ? item.value : null)
                        : categoryValues?.includes(item.value ? item.value : null), id: item.id, name: item.name, value: item.value, text: item.text, onChange: (event) => updateCheckboxArray(event.target.value, event.target.name ?? '') }))))))),
        items.map((item) => (React.createElement(S.CheckboxAreaContainer, { key: item.id },
            React.createElement(S.Item, { isActive: activeId === item.value, onClick: (event) => {
                    event.preventDefault();
                    onSelect(activeId === item.value ? '' : item.value ?? '');
                } },
                React.createElement("span", null, item.text),
                React.createElement(S.Arrow, null,
                    React.createElement(SvgChevronDown, null))),
            React.createElement(S.CheckboxAreaItems, { active: activeId === item.value }, item.options?.map((option) => (React.createElement(FilterCheckItem, { key: option.id, type: "checkbox", checked: filterValue && option.value === filterValue['year'], id: option.id, name: option.name, value: option.value, text: option.text, onChange: (event) => onFilterChange && onFilterChange(item.value, event.target.value ?? 'all') }))))))),
        sortByOptions && (React.createElement(S.CheckboxAreaContainer, null,
            React.createElement(S.Item, { isActive: activeId === 'SortBy', onClick: (event) => {
                    event.preventDefault();
                    onSelect(activeId === 'SortBy' ? '' : 'SortBy' ?? '');
                } },
                React.createElement("span", null, "Sort By"),
                React.createElement(S.Arrow, null,
                    React.createElement(SvgChevronDown, null))),
            React.createElement(S.CheckboxAreaItems, { active: activeId === 'SortBy' }, sortByOptions.map((option) => (React.createElement(FilterCheckItem, { key: option.id, type: "checkbox", checked: option.value === sortByValue, id: option.id, value: option.value, text: option.text, onChange: (event) => onSortChange && onSortChange(event.target.value ?? '') })))))),
        setVisible && (React.createElement(S.MobileButton, { branding: "primary", title: "See Results", onClick: () => setVisible(false) }))));
};
export default FilterList;
